<template>
  <div :class="[baseCss, 'select-none', 'p-1', 'truncate', bgColor, `text-${align}`, setTextColor()]">
    <span v-html="text" :class="[capitalize ? 'uppercase' : null, 'bcq-text-field-label-text', 'text-xs']" /><sup v-if="required" :class="['text-base', 'bcq-text-field-label-required']"> * </sup>
  </div>
</template>
<script>
import methods from '../../mixins/methods'
import computed from '../../mixins/computed'
import props from '../../mixins/props'

export default {
  name: 'TextFieldLabel',
  mixins: [
    methods,
    props,
    computed
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('text-field-label')
    }
  },
  props: {
    bgColor: {
      type: String
    },
    color: {
      type: String
    },
    colorLightness: {
      type: Number
    },
    text: {
      type: String,
      default: '&nbsp;'
    },
    align: {
      type: String,
      default: 'auto',
      validator: value => {
        return ['left', 'center', 'right', 'text-justify', 'auto'].includes(value)
      }
    },
    capitalize: {
      type: Boolean
    },
    required: {
      type: Boolean,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/text-field-label/text-field-label.vue